import { FormStepsProps } from ".";

export const sponsoredSteps: Record<number, FormStepsProps> = {
  0: {
    id: "Step 1",
    icon: "Charger",
    heading: "Start",
    numDots: 0,
  },
  1: {
    id: "Step 2",
    icon: "Charger",
    heading: "Tiers",
    numDots: 0,
  },
  2: {
    id: "Step 3",
    icon: "Charger",
    heading: "Chargepoint",
    fields: [
      "chargepoint.serialNumber",
      "chargepoint.connectors",
      "chargepoint.model",
      "chargepoint.maxPower",
      "chargepoint.addSim",
    ],
    numDots: 6,
  },
  3: {
    id: "Step 4",
    icon: "Briefcase",
    heading: "Company",
    fields: [
      "company.name",
      "company.taxID",
      "company.address.street",
      "company.address.city",
      "company.address.zipCode",
      "company.address.country",
    ],
    numDots: 5,
  },
  4: {
    id: "Step 5",
    icon: "Users",
    heading: "Employer details",
    fields: [
      "team.owner.name",
      "team.owner.telephone",
      "team.owner.email",
      "team.finace.name",
      "team.finance.telephone",
      "team.finance.email",
    ],
    numDots: 4,
  },
  5: {
    id: "Step 6",
    icon: "User",
    heading: "Employee data",
    fields: [
      "team.employee.name",
      "team.employee.telephone",
      "team.employee.email",
    ],
    numDots: 3,
  },
  6: {
    id: "Step 7",
    icon: "Tool",
    heading: "Team Installer",
    fields: [
      "installation.installer.name",
      "installation.installer.telephone",
      "installation.installer.email",
      "installation.installer.installationNotes",
    ],
    numDots: 2,
  },
  7: {
    id: "Step 8",
    icon: "Home",
    heading: "Private EV charger address",
    fields: [
      "site.name",
      "site.address.street",
      "site.address.city",
      "site.address.zipCode",
      "site.address.country",
    ],
    numDots: 1,
  },
  8: {
    id: "Step 9",
    icon: "Check",
    heading: "Submit",
    numDots: 0,
  },
};

export const numSponsoredSteps = Object.keys(sponsoredSteps).length;
